import { makeObservable, observable } from 'mobx';
import { computedFn } from 'mobx-utils';

import type { TWellListCombinedData } from 'src/entities/tab/TabEntity';
import { BaseWidgetEntityWithWellId } from 'src/entities/widget/BaseWidgetEntityWithWellId';
import type { WidgetEntity } from 'src/entities/widget/WidgetEntity';

import { FilterWidgetEntity } from '../filter-widget/FilterWidget.entity';

import type { GroupManager } from './GroupManager';

export class GroupSelectStore {
  readonly groupManager: GroupManager;

  @observable widgets: WidgetEntity[];

  wellListData: TWellListCombinedData;

  constructor(groupManager: GroupManager, widgets: WidgetEntity[], wellListEntity: TWellListCombinedData) {
    this.groupManager = groupManager;
    this.widgets = widgets;
    this.wellListData = wellListEntity;

    makeObservable(this);
  }

  getWellIdInGroup = computedFn((groupId: string | null): number | null => {
    const currentGroup = this.groupManager.getWidgetsByGroupId(groupId);

    for (const widget of currentGroup) {
      if (widget instanceof BaseWidgetEntityWithWellId && widget.wellId) {
        return widget.wellId;
      }
    }

    if (this.wellListData.panelState?.groupId === groupId) {
      return this.wellListData.store.selectedWellId;
    }

    return null;
  });

  getUsesFilter = computedFn((groupId: string | null): boolean => {
    const currentGroup = this.groupManager.getWidgetsByGroupId(groupId);

    return !!currentGroup?.some((widget) => widget instanceof FilterWidgetEntity);
  });

  getUsesByAnotherWidgets = computedFn((groupId: string): boolean => {
    const currentGroup = this.groupManager.getWidgetsByGroupId(groupId);

    return currentGroup.length > 0;
  });
}
